module.exports = __webpack_public_path__ + "static/media/software.6e27a26c.png";